import { LoadingSpinner } from '@web_opxp/components';
import { AuthActions } from '@web_opxp/features';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppSelectors } from '../../app';
import ENV from '../../base/env';
import { redirectToCheckoutCancel, redirectToCheckoutSuccess } from '../../base/historyService';
import MoneybackGuarantee from '../../components/moneyback/MoneybackGuarantee';
import ChargebeeService from '../chargebeeService';
import * as Selectors from '../selectors';
import { CheckoutActions } from '../slice';

interface IProgressProps {
  planId: string;
}

export default function Progress() {
  const { planId } = useParams<IProgressProps>();

  const dispatch = useDispatch();

  const isAppLoading = useSelector(AppSelectors.isAppLoading);
  const hostedPage = useSelector(Selectors.getHostedPageData);

  useEffect(() => {
    if (isAppLoading || !planId || !dispatch) {
      return;
    }
    // wait for product id and fire start action as soon as product id is given
    dispatch(CheckoutActions.startCheckout(planId));
  }, [dispatch, isAppLoading, planId]);

  useEffect(() => {
    if (!hostedPage) {
      return;
    }
    ChargebeeService.openCheckout(
      hostedPage,
      () => {
        dispatch(AuthActions.setUserPremium());
        redirectToCheckoutSuccess();
      },
      redirectToCheckoutCancel,
      undefined,
      redirectToCheckoutCancel
    );
  }, [hostedPage, dispatch]);

  return (
    <>
      <div className="panel" data-testid="progress-panel">
        <LoadingSpinner assetsUrl={ENV.AssetsBaseUrl} />
      </div>
      <MoneybackGuarantee />
    </>
  );
}
